import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, Booking, VehicleStatus, Workflow } from "../../../../logic/api";
import FlowRender from "../flow/FlowRender";
import ToolBoxItems from "../toolbox/ToolBoxItems";
import { SessionContext } from "../../../../utility/useSession";
import NotchedCard from "../../../../components/cards/NotchedCard/NotchedCard";
import { useTranslation } from "react-i18next";

const WorkflowBooking: React.FunctionComponent<{
    booking: Booking;
}> = (props) => {
    const session = useContext(SessionContext);
    const toolBoxItems = ToolBoxItems();
    const fetchWorkflow = api.hooks.workflow.getWorkflow();
    const [workflow, setWorkflow] = useState<Workflow | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
        let cancelled = false;


        if (props.booking.packageCode != null) {
            fetchWorkflow.send(session.current.context, {
                productCode: props.booking.packageCode
            }, (result) => {
                if (cancelled == false) {
                    setWorkflow(result);
                }
            });
        } else {
            setWorkflow(null);
        }

        return () => {
            cancelled = true;
        }
    }, [props.booking.id]);

    const completed: string[] = [];

    if (props.booking.actionsCompleted != null) {
        for (const act of props.booking.actionsCompleted) {
            completed.push(act.action);
        }
    }



    if (workflow == null) {
        return <Fragment></Fragment>
    }

    if (workflow.actions == null || workflow.actions.length == 0) {
        return <Fragment></Fragment>
    }


    if (props.booking.vehicle.statusId == VehicleStatus.CheckedIn) {
        for (const act of workflow.actions) {
            if (act.toolRef == "checkin") {
                completed.push(act.id);
            }
        }
    }


    return <Fragment>
        <div style={{ marginBottom: 20, marginTop: 50 }}>
            <NotchedCard label={t("workflow.workflowProgress")}>
                <FlowRender isProcessView={true} completed={completed} selectedId={null} toolBoxItems={toolBoxItems} flow={workflow} onActionSelected={() => {
                    console.log("select action - workflow");
                }}></FlowRender>
            </NotchedCard>
        </div>
    </Fragment>

}

WorkflowBooking.propTypes = {
    booking: propTypes.any.isRequired
}
export default WorkflowBooking;